import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "serverbg",
  style: {
    backgroundImage: 'url(https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb6-bg_stop.jpg)'
  }
};
const _hoisted_3 = {
  class: "server_box acea-row row-between-wrapper"
};
const _hoisted_4 = {
  class: "server_item acea-row row-column"
};
const _hoisted_5 = {
  class: "server_item_pic acea-row row-center-wrapper"
};
const _hoisted_6 = {
  class: "server_item acea-row row-column"
};
const _hoisted_7 = {
  class: "server_item_pic acea-row row-center-wrapper"
};
const _hoisted_8 = {
  class: "server_item acea-row row-column"
};
const _hoisted_9 = {
  class: "server_item_pic acea-row row-center-wrapper"
};
const _hoisted_10 = {
  class: "server_item acea-row row-column"
};
const _hoisted_11 = {
  class: "server_item_pic acea-row row-center-wrapper"
};
const _hoisted_12 = {
  class: "server_item acea-row row-column"
};
const _hoisted_13 = {
  class: "server_item_pic acea-row row-center-wrapper"
};
const _hoisted_14 = {
  class: "server_item acea-row row-column"
};
const _hoisted_15 = {
  class: "server_item_pic acea-row row-center-wrapper"
};
const _hoisted_16 = {
  class: "material_test"
};
const _hoisted_17 = {
  class: "material_test_one"
};
const _hoisted_18 = {
  class: "material_test_two acea-row row-top"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "material_test_thee acea-row row-between-wrapper"
};
const _hoisted_21 = ["onMouseenter", "onClick"];
const _hoisted_22 = {
  class: "material_test_item_box_pic"
};
const _hoisted_23 = {
  class: "material_test_item_box acea-row row-bottom"
};
const _hoisted_24 = {
  key: 0,
  class: "material_test_item_box_btn acea-row row-center-wrapper"
};
const _hoisted_25 = {
  key: 1,
  class: "material_test_item_box_more"
};
const _hoisted_26 = {
  class: "material_test_item_box_title"
};
const _hoisted_27 = {
  class: "material_test_item_box_deso"
};
const _hoisted_28 = {
  key: 2,
  class: "material_test_item_box_txt"
};
const _hoisted_29 = {
  class: "analog_computation"
};
const _hoisted_30 = {
  class: "analog_computation_one"
};
const _hoisted_31 = {
  class: "analog_computation_two acea-row row-top"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  class: "analog_computation_thee acea-row row-between-wrapper"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "analog_computation_item_pic"
};
const _hoisted_36 = {
  class: "analog_computation_item_title acea-row row-center-wrapper"
};
const _hoisted_37 = {
  class: "zixunall"
};
const _hoisted_38 = {
  class: "zixun"
};
const _hoisted_39 = {
  class: "zixun_three acea-row row-center-wrapper"
};
const _hoisted_40 = {
  class: "zixun_four acea-row row-between-wrapper"
};
const _hoisted_41 = {
  class: "zixun_four_left"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  class: "zixun_tuijian_one"
};
const _hoisted_44 = {
  class: "zixun_tuijian_two acea-row row-between-wrapper"
};
const _hoisted_45 = {
  class: "zixun_tuijian_time"
};
const _hoisted_46 = {
  class: "zixun_tuijian_daytxt"
};
const _hoisted_47 = {
  class: "zixun_tuijian_yeartxt"
};
const _hoisted_48 = {
  class: "zixun_tuijian_txt"
};
const _hoisted_49 = {
  class: "zixun_tuijian_title"
};
const _hoisted_50 = {
  class: "zixun_tuijian_deso"
};
const _hoisted_51 = {
  class: "zixun_four_right"
};
const _hoisted_52 = ["onClick"];
const _hoisted_53 = {
  class: "zixun_news_time"
};
const _hoisted_54 = {
  class: "zixun_news_daytxt"
};
const _hoisted_55 = {
  class: "zixun_news_yeartxt"
};
const _hoisted_56 = {
  class: "zixun_news_txt"
};
const _hoisted_57 = {
  class: "zixun_news_title"
};
const _hoisted_58 = {
  class: "zixun_news_deso"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_el_image = _resolveComponent("el-image");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  const _component_loading = _resolveComponent("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu
  }, null, 8, ["xzmenu"]), _createVNode(_component_swiper, {
    "slides-per-view": 1,
    modules: $setup.modules,
    navigation: "",
    pagination: {
      clickable: true
    },
    style: {
      "height": "400px",
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [_createVNode(_component_el_image, {
        src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/banner2.jpg"
      })]),
      _: 1
    }), _createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [_createVNode(_component_el_image, {
        src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/banner2.jpg"
      })]),
      _: 1
    }), _createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [_createVNode(_component_el_image, {
        src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/banner2.jpg"
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["modules"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb6-icon1.png"
  })]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "server_item_txt acea-row row-center-wrapper"
  }, " 1.技术标准查询 ", -1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb6-icon2.png"
  })]), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "server_item_txt acea-row row-center-wrapper"
  }, " 2.获取报告模版 ", -1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb6-icon3.png"
  })]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "server_item_txt acea-row row-center-wrapper"
  }, " 3.获取试验方案 ", -1))]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb6-icon4.png"
  })]), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "server_item_txt acea-row row-center-wrapper"
  }, " 4.获取试验周期 ", -1))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb6-icon5.png"
  })]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "server_item_txt acea-row row-center-wrapper"
  }, " 5.快速报价 ", -1))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb6-icon6.png"
  })]), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "server_item_txt acea-row row-center-wrapper"
  }, " 6.定制非标试验 ", -1))])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cailiaoceshi_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(item.cate_name), 1), _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cateson_list, (item_cateson, index_cateson) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([$data.cate_jiance_id == item_cateson.id ? 'cidjiacu' : 'cidzhengchang']),
        onClick: $event => $options.SelectCateSonId(item_cateson.id)
      }, _toDisplayString(item_cateson.cate_name), 11, _hoisted_19);
    }), 256))]), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.project_list, (item_project, index_project) => {
      return _openBlock(), _createElementBlock("div", {
        class: "material_test_item",
        onMouseenter: $event => $options.handleMouseEnter(item_project.id),
        onMouseleave: _cache[0] || (_cache[0] = $event => $options.handleMouseLeave()),
        onClick: $event => $options.goprojectdetail(item_project.id, 2)
      }, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_image, {
        src: item_project.image,
        class: "material_test_item_box_el_image"
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_23, [$data.xzfwid == item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[11] || (_cache[11] = [_createElementVNode("div", {
        class: "material_test_item_box_yuyue"
      }, "立即预约", -1)]))) : _createCommentVNode("", true), $data.xzfwid == item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(item_project.title), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(item_project.deso), 1)])) : _createCommentVNode("", true), $data.xzfwid != item_project.id ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item_project.title), 1)) : _createCommentVNode("", true)])], 40, _hoisted_21);
    }), 256))])]);
  }), 256)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.monijisuan_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(item.cate_name), 1), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cateson_list, (item_cateson, index_cateson) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([$data.cate_moni_id == item_cateson.id ? 'cidjiacu' : 'cidzhengchang']),
        onClick: $event => $options.SelectCateMoniId(item_cateson.id)
      }, _toDisplayString(item_cateson.cate_name), 11, _hoisted_32);
    }), 256))]), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.project_list, (item_project, index_project) => {
      return _openBlock(), _createElementBlock("div", {
        class: "analog_computation_item",
        onClick: $event => $options.goprojectdetail(item_project.id, 3)
      }, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_el_image, {
        src: item_project.image,
        class: "analog_computation_item_el_image"
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_36, _toDisplayString(item_project.title), 1), _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "analog_computation_item_btn acea-row row-center-wrapper"
      }, [_createElementVNode("div", {
        class: "analog_computation_item_yuyue"
      }, "立即预约")], -1))], 8, _hoisted_34);
    }), 256))])]);
  }), 256)), _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"aboubg\" style=\"background-image:url(https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/inb4-bg.jpg);\"><div class=\"about_one acea-row row-between-wrapper\"><div class=\"about_one_left\"><div class=\"about_one_ziysys acea-row row-top\">自营实验室</div><div class=\"about_one_qlxianc acea-row row-top\">亲临现场，测试过程尽收眼底，身临其境般的线上体验。</div><div class=\"about_one_zhichixiadan acea-row row-top\">搭建以SEM、 XPS、TEM等大型精密仪器装置为主体的实验中心，为科研创新做出贡献。</div><div class=\"about_one_pcxiadan acea-row row-top\">支持PC端下单预约，精准把控各类科研需求，形成流程化的解决方案。</div></div><div class=\"about_one_right\"><div class=\"about_one_title acea-row row-between-wrapper\"><div>企业介绍</div><div class=\"about_one_more acea-row row-top\">了解详情&gt;</div></div><div class=\"about_one_deso acea-row row-top\"> 四川众诚表征实验检测有限公司成立了化学实验室、微生物实验室、力学实验室、材料实验室、医学实验室、高分子实验室、声学实验室等。坚持基础研究与应用研究并重、应用研究和技术转化相结合。开展了研发设计、分析检测、试验验证、共性加工、信息及知识产权等服务,为科技型企业创新提供公共服务。 </div></div></div><div class=\"about_two acea-row row-between-wrapper\"><div class=\"about_two_item acea-row row-top\"><div class=\"about_two_txt acea-row row-center-wrapper\"> 技术领先 </div><div class=\"about_two_txt acea-row row-center-wrapper\">设备先进</div></div><div class=\"about_two_item acea-row row-top\"><div class=\"about_two_txt acea-row row-center-wrapper\"> 服务好 </div><div class=\"about_two_txt acea-row row-center-wrapper\">一对一专业专属</div></div><div class=\"about_two_item acea-row row-top\"><div class=\"about_two_txt acea-row row-center-wrapper\"> 速度快 </div><div class=\"about_two_txt acea-row row-center-wrapper\">平均3.5天出结果</div></div><div class=\"about_two_item acea-row row-top\"><div class=\"about_two_txt acea-row row-center-wrapper\"> 设备齐全 </div><div class=\"about_two_txt acea-row row-center-wrapper\">优选仪器设备</div></div></div></div>", 1)), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_cache[13] || (_cache[13] = _createElementVNode("div", {
    class: "zixun_one"
  }, "平台资讯", -1)), _cache[14] || (_cache[14] = _createElementVNode("div", {
    class: "zixun_two"
  }, "我们会第一时间更新动态，分享给您们", -1)), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 1 ? 'zixunbg' : '']]),
    onClick: _cache[1] || (_cache[1] = $event => $options.selecetnewcid(1))
  }, "行业新闻", 2), _createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 2 ? 'zixunbg' : '']]),
    onClick: _cache[2] || (_cache[2] = $event => $options.selecetnewcid(2))
  }, "文库资料", 2), _createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 3 ? 'zixunbg' : '']]),
    onClick: _cache[3] || (_cache[3] = $event => $options.selecetnewcid(3))
  }, "企业资讯", 2), _createElementVNode("div", {
    class: _normalizeClass(["zixun_three_item", [$data.xznewcid == 4 ? 'zixunbg' : '']]),
    onClick: _cache[4] || (_cache[4] = $event => $options.selecetnewcid(4))
  }, "常见问题", 2)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsone_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "zixun_tuijian",
      onClick: $event => $options.goxinwen(item.id, 5)
    }, [_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_image, {
      class: "zixun_tuijian_image",
      src: item.image_input
    }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(item.daytxt), 1), _createElementVNode("div", _hoisted_47, _toDisplayString(item.yeartxt), 1)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(item.deso), 1)])])], 8, _hoisted_42);
  }), 256))]), _createElementVNode("div", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.news_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "zixun_news acea-row row-between-wrapper",
      onClick: $event => $options.goxinwen(item.id, 5)
    }, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(item.daytxt), 1), _createElementVNode("div", _hoisted_55, _toDisplayString(item.yeartxt), 1)]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_58, _toDisplayString(item.deso), 1)])], 8, _hoisted_52);
  }), 256))])])])]), _createVNode(_component_zrcfooter), _createVNode(_component_loading, {
    status: $data.loadingStatus
  }, null, 8, ["status"])]);
}